import { Vector2 } from "three";
import { DOMHitTest } from "../../dom-tools/DOMHitTest";

export class DragData<T>
{
  value:T;
  
  position:Vector2;
  
  shiftKey:boolean;
  ctrlKey:boolean;
  altKey:boolean;

  static create<T>( e:MouseEvent|TouchEvent, t:T )
  {
    let data = new DragData<T>();

    data.value = t;

    data.position = DOMHitTest.getPointerPosition( e );
   
    data.shiftKey = e.shiftKey;
    data.ctrlKey  = e.ctrlKey;
    data.altKey   = e.altKey;
    
    return data;
  }
}